import React from "react";

const Notification = ({ type = "success", message, onClose }) => {
  if (!message) return null;
  return (
    <div
      className={`mb-4 px-4 py-3 rounded relative ${
        type === "success"
          ? "bg-green-100 border border-green-400 text-green-700"
          : "bg-red-100 border border-red-400 text-red-700"
      }`}
      role="alert"
    >
      <span className="block sm:inline">{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-0 bottom-0 right-0 px-4 py-3"
        >
          <svg className="fill-current h-6 w-6" viewBox="0 0 20 20">
            <title>Close</title>
            <path d="M14.348 5.652a1 1 0 10-1.414-1.414L10 7.586 7.066 4.652A1 1 0 105.652 6.066L8.586 9l-2.934 2.934a1 1 0 101.414 1.414L10 10.414l2.934 2.934a1 1 0 101.414-1.414L11.414 9l2.934-2.934z"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default Notification;